import router from '../router'
import axios from 'axios'
import store from '@/store'
import { getToken, getAuth, getAuthCode, checkAuth } from '@/utils/auth'

// axios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem("oauth_token")}`
let unauthorized = false;

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_API_URL,
  // 超时
  timeout: 30000
})


// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem("oauth_token")}`
    if (!checkAuth()) {
      getAuthCode().then(t => {
        config.headers['Authorization'] = `Bearer ${t}`
        return config
      }).catch(err => {
        console.log('interceptor,getauth wrong', err)
        return config
      })
    } else {
      config.headers['Authorization'] = `Bearer ${localStorage.getItem("oauth_token")}`
      return config
    }
    
  },
  error => {
  }
)

// 响应拦截器
service.interceptors.response.use(res => {
  let code = res.data.code || res.code
  if (code === 402) {
    console.log('auth goes wrong!')
  } else if (code !== 200) {
    return res.data;
  } else {
    unauthorized = false;
    return res.data
  }
},
  error => {
    if (error.response.status === 402) {
      console.log('auth goes wrong!')
    }
  }
)

export default service
